import httpMethod from 'services/update2025/httpMethod';
import classNames from "classnames";
import { VNeIDJobContext } from "components/vneid-job/VNeIDJobContext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { callNodeVNeIDJob, listServerVNeIDJob, listServiceNameVNeIDJob, validateConfig } from "services/VNeIDJobService";
import { actionClone, actionUpdate, actionView } from "utils/action";
import { handleError } from "utils/handleError";
import VNeIDJobSuggestion from "./VNeIDJobSuggestion";

export const VNeIDJobEditor = (props) => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["vneid-job", "config", "common"]);

    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const vneidJobContext = useContext(VNeIDJobContext);
    const { vneidDialog, setVneidDialog, submitted, setSubmitted, index, setIndex, valueForm, setValueForm, resetValueForm } = vneidJobContext;
    const [validForm, setValidForm] = useState(false);

    const [titleEditor, setTitleEditor] = useState(t("vneid-job.titleCreateDetail"));

    const [optionServer, setOptionServer] = useState([]);
    const [openModalSuggestion, setOpenModalSuggestion] = useState(false);

    const [optionServiceName, setOptionServiceName] = useState([]);

    const getListServer = () => {
        listServerVNeIDJob(headers, {
            code: valueForm?.appCode,
        })
            .then((res) => {
                if (res.status === 200) {
                    setOptionServer(
                        res.data.map((e) => {
                            return { label: e, value: e };
                        })
                    );
                }
            })
            .catch((e) => { })
            .finally(() => { });
    };

    const getListServiceName = () => {
        listServiceNameVNeIDJob(headers, {})
            .then((res) => {
                if (res.status === 200) {
                    setOptionServiceName(
                        res.data.map((e) => {
                            return { label: e.name, value: e.code };
                        })
                    );
                }
            })
            .catch((e) => { })
            .finally(() => { });
    };

    useEffect(() => {
        // getListServer();
        getListServiceName();
    }, []);

    useEffect(() => {
        getListServer();
    }, [valueForm?.appCode]);

    useEffect(() => {
        if (!valueForm?.action) {
            onInputChange("", "serverType");
        }
    }, [valueForm.appCode]);

    useEffect(() => {
        // create
        if (!valueForm?.jobId) {
            setTitleEditor(t("vneid-job.titleCreateDetail"));
            return;
        }
        // update
        if (actionUpdate === valueForm?.action) {
            setTitleEditor(t("vneid-job.titleUpdateDetail"));
            return;
        }
        // clonne
        if (actionClone === valueForm?.action) {
            setTitleEditor(t("vneid-job.titleCloneDetail"));
            return;
        }
        // view
        else {
            setTitleEditor(t("vneid-job.titleDetail"));
        }
    });

    useEffect(() => { });

    const onInputChange = (e, name) => {
        const val = e.target?.value || "";
        let _config = { ...valueForm };
        _config[`${name}`] = val;

        setValueForm(_config);
    };
    const onCheckboxChange = (e) => {
        let _config = { ...valueForm, multipleJobs: e.checked };
        setValueForm(_config);
    };

    const hideDialog = () => {
        setSubmitted(false);
        resetValueForm();
        setVneidDialog(false);
    };

    const saveConfigAction = () => {
        setValidForm(true);
        validateConfig(valueForm)
            .then(() => {
                if (!valueForm?.jobId) {
                    // Creating
                    return callNodeVNeIDJob(headers, { ...valueForm, param: "saveOrUpdate" }).then((res) => {
                        toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("inform.created", { ns: "common", object: t("vneid-job") }), life: 3000 });
                        setValidForm(false);
                        setSubmitted(true);
                        hideDialog();
                    });
                } else if (actionClone === valueForm?.action) {
                    // cloning
                    const body = { ...valueForm, jobId: "", param: "saveOrUpdate" };
                    return callNodeVNeIDJob(headers, body).then((res) => {
                        toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("inform.created", { ns: "common", object: t("vneid-job") }), life: 3000 });
                        setValidForm(false);
                        setSubmitted(true);
                        hideDialog();
                    });
                } else {
                    // Updating
                    return callNodeVNeIDJob(headers, { ...valueForm, param: "saveOrUpdate" }).then((res) => {
                        toast.current.show({ severity: "success", summary: t("success", { ns: "common" }), detail: t("inform.updated", { ns: "common", object: t("vneid-job") }), life: 3000 });
                        setValidForm(false);
                        setSubmitted(true);
                        hideDialog();
                    });
                }
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => { });
    };

    const checkView = () => {
        if (actionClone === valueForm?.action) {
            return false;
        }
        if (actionView === valueForm?.action) {
            return true;
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={vneidDialog} style={{ width: "70%" }} header={titleEditor.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* key */}
                                <div className="field col-12">
                                    <label htmlFor="key">
                                        {t("vneid-job.key")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <InputText
                                        id="jobKey"
                                        value={valueForm?.jobKey}
                                        keyfilter={/[^\s]/}
                                        maxLength={100}
                                        onChange={(e) => onInputChange(e, "jobKey")}
                                        required
                                        autoFocus
                                        disabled={(valueForm?.jobId && actionUpdate === valueForm?.action) || actionView === valueForm?.action}
                                        className={classNames({ "p-invalid": validForm && !valueForm?.jobKey })}
                                    />
                                    {validForm && !valueForm?.jobKey && <small className="p-invalid">{t("jobKey.required")}.</small>}
                                </div>
                                {/* muntiple jobs */}
                                <div className="field col-12 md:col-2" style={{ display: "flex" }}>
                                    <Checkbox id="multipleJobs" checked={valueForm?.multipleJobs} onChange={(e) => onCheckboxChange(e)} disabled={valueForm?.jobId} />
                                    <label htmlFor="multipleJobs">{t("vneid-job.multiplejobs")}</label>
                                </div>

                                {/* service namme */}
                                <div className="field col-12">
                                    <label htmlFor="server">
                                        {t("vneid-job.serviceName")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <Dropdown
                                        id="appCode"
                                        required
                                        value={valueForm?.appCode}
                                        options={optionServiceName}
                                        onChange={(e) => {
                                            onInputChange(e, "appCode");
                                        }}
                                        disabled={(valueForm?.appCode && actionUpdate === valueForm?.action) || actionView === valueForm?.action || actionClone === valueForm?.action}
                                        className={classNames({ "p-invalid": validForm && !valueForm?.appCode })}
                                    />
                                    {validForm && !valueForm?.appCode && <small className="p-invalid">{t("serverName.required")}.</small>}
                                </div>

                                {/* server type */}

                                <div className="field col-12">
                                    <label htmlFor="name">
                                        {t("vneid-job.serverType")}
                                        {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <InputText id="serverType" value={valueForm?.serverType} maxLength={100} onChange={(e) => onInputChange(e, "serverType")} required disabled={actionView === valueForm?.action} />
                                    {/* {valueForm.serviceName === "integrate-internal-send" && !valueForm?.serverType && <small className="p-invalid">{t("serverType.required")}.</small>} */}
                                </div>

                                {/* Tên */}
                                <div className="field col-12">
                                    <label htmlFor="name">
                                        {t("vneid-job.name")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <InputText id="jobName" value={valueForm?.jobName} maxLength={100} onChange={(e) => onInputChange(e, "jobName")} required disabled={actionView === valueForm?.action} className={classNames({ "p-invalid": validForm && !valueForm?.jobName })} />
                                    {validForm && !valueForm?.jobName && <small className="p-invalid">{t("jobName.required")}.</small>}
                                </div>
                                {/* Tên class */}
                                <div className="field col-12">
                                    <label htmlFor="className">
                                        {t("vneid-job.className")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <InputText id="className" value={valueForm?.className} maxLength={100} onChange={(e) => onInputChange(e, "className")} required disabled={valueForm?.jobId} className={classNames({ "p-invalid": validForm && !valueForm?.className })} />
                                    {validForm && !valueForm?.className && <small className="p-invalid">{t("className.required")}.</small>}
                                </div>

                                {/* Nhóm */}
                                <div className="field  col-12">
                                    <label htmlFor="group">
                                        {t("vneid-job.group")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <InputText id="jobGroup" value={valueForm?.jobGroup} maxLength={100} onChange={(e) => onInputChange(e, "jobGroup")} required disabled={valueForm?.jobId} className={classNames({ "p-invalid": validForm && !valueForm?.jobGroup })} />
                                    {validForm && !valueForm?.jobGroup && <small className="p-invalid">{t("jobGroup.required")}.</small>}
                                </div>
                                {/* Lịch chạy */}
                                <div className="field col-12 ">
                                    <label htmlFor="cronExpression">
                                        {t("vneid-job.cronExpression")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <div className="p-inputgroup flex-1">
                                        <InputText id="cronExpression" value={valueForm?.cronExpression} maxLength={200} onChange={(e) => onInputChange(e, "cronExpression")} required disabled={checkView()} className={classNames({ "p-invalid": validForm && !valueForm?.cronExpression })} />
                                        <Button
                                            icon="pi pi-search"
                                            className="p-button-warning"
                                            onClick={() => {
                                                setOpenModalSuggestion(true);
                                            }}
                                            disabled={!valueForm.server}
                                        />
                                    </div>
                                    {/* <InputText id="cronExpression" value={valueForm?.cronExpression} maxLength={200} onChange={(e) => onInputChange(e, "cronExpression")} required disabled={checkView()} className={classNames({ "p-invalid": validForm && !valueForm?.cronExpression })} /> */}
                                    {validForm && !valueForm?.cronExpression && <small className="p-invalid">{t("cronExpression.required")}.</small>}
                                </div>

                                {/* Số lượng */}
                                <div className="field col-12 ">
                                    <label htmlFor="rownum">
                                        {t("vneid-job.rownum")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <InputText id="configRow" value={valueForm?.configRow} maxLength={200} onChange={(e) => onInputChange(e, "configRow")} required disabled={checkView()} className={classNames({ "p-invalid": validForm && !valueForm?.configRow })} />
                                    {validForm && !valueForm?.configRow && <small className="p-invalid">{t("configRow.required")}.</small>}
                                </div>
                                {/* Server */}
                                <div className="field col-12">
                                    <label htmlFor="server">
                                        {t("vneid-job.server")}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <Dropdown
                                        id="server"
                                        required
                                        value={valueForm?.server}
                                        options={optionServer}
                                        onChange={(e) => onInputChange(e, "server")}
                                        disabled={(valueForm?.jobId && actionUpdate === valueForm?.action) || actionView === valueForm?.action}
                                        className={classNames({ "p-invalid": validForm && !valueForm?.server })}
                                    />
                                    {validForm && !valueForm?.server && <small className="p-invalid">{t("server.required")}.</small>}
                                </div>
                                {/* Mô tả */}
                                <div className="field col-12">
                                    <label htmlFor="description">{t("vneid-job.description")}</label>
                                    <InputTextarea id="description" value={valueForm?.description || ""} maxLength={1000} onChange={(e) => onInputChange(e, "description")} rows={3} cols={20} disabled={checkView()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* save */}
                        {!checkView() && (
                            <Button
                                style={{
                                    width: "max-content",
                                }}
                                className="mr-2"
                                label={t("save", { ns: "common" })}
                                icon="pi pi-check"
                                onClick={saveConfigAction}
                            />
                        )}
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
            {openModalSuggestion && <VNeIDJobSuggestion setOpenModalSuggestion={setOpenModalSuggestion} server={valueForm?.server} valueForm={valueForm} setValueForm={setValueForm} />}
        </>
    );
};
